import { Controller } from "@hotwired/stimulus"
import { post } from "@rails/request.js"

export default class extends Controller {
  static values = { url: String, current: Number }
  static targets = ["star", "label", "spinner"]

  connect() {
    this.render(this.currentValue)
  }

  async rate(event) {
    const stars = parseInt(event.currentTarget.dataset.value)
    this.currentValue = stars
    this.render(stars)
    this.setLoading(true)
    try {
      await post(this.urlValue, {
        body: JSON.stringify({ stars }),
        contentType: "application/json",
        responseKind: "turbo-stream"
      })
    } finally {
      this.setLoading(false)
    }
  }

  highlight(event) {
    const hovered = parseInt(event.currentTarget.dataset.value)
    this.starTargets.forEach(s => {
      const v = parseInt(s.dataset.value)
      s.classList.toggle("text-primary-400", v <= hovered)
      s.classList.toggle("text-gray-700", v > hovered)
    })
  }

  reset() {
    this.render(this.currentValue)
  }

  render(value) {
    this.starTargets.forEach(s => {
      const v = parseInt(s.dataset.value)
      s.classList.toggle("text-primary-400", v <= value)
      s.classList.toggle("text-gray-700", v > value)
    })
    if (this.hasLabelTarget) {
      this.labelTargets.forEach(l => { l.textContent = value })
    }
  }

  setLoading(loading) {
    // Spinner: visible while request is in flight
    if (this.hasSpinnerTarget) {
      this.spinnerTarget.classList.toggle("hidden", !loading)
    }
    // Stars: dimmed + non-interactive during request
    this.starTargets.forEach(s => {
      s.classList.toggle("opacity-30", loading)
      s.classList.toggle("pointer-events-none", loading)
    })
  }
}
